/* eslint-disable */

function handleIntersect(entry) {
    document.documentElement.style.setProperty(
        "--yitm-hero-decimal",
        entry[0].intersectionRatio
    );
}

export const yitmScroll = () => {
	const heroImage = document.getElementById("heroImage");

    if(heroImage) {

        const container = heroImage.parentElement;
        const firstBlock = document.getElementById("contentBlock_01");
    
        const heroHeight = heroImage.offsetHeight;
    
        container.style.paddingTop = heroHeight + "px";
    
        function buildThresholdList() {
            const thresholds = [];
            const numSteps = 100;
    
            for (let i = 1.0; i <= numSteps; i++) {
                const ratio = i / numSteps;
                thresholds.push(ratio);
            }
    
            thresholds.push(0);
            return thresholds;
        }
    
        const observerOptions = {
            root: null,
            rootMargin: "0px",
            threshold: buildThresholdList()
        };
    
        const observer = new IntersectionObserver(handleIntersect, observerOptions);
    
        observer.observe(firstBlock);

    }
};

window.addEventListener("resize", () => {
	yitmScroll();
});

window.addEventListener("load", () => {
	yitmScroll();
});




// WEBPACK FOOTER //
// ./frontend/helpers/yitmScroll.js